import React from "react";
import { TableColumn } from "../../models/table";
import styles from "./Table.module.scss";

interface Props {
  columns: TableColumn[];
}

const TableHeader = ({ columns }: Props) => {
  const gridTemplateColumns = columns.map((c) => c.width || "1fr").join(" ");

  return (
    <div className={styles.tableHeader} style={{ gridTemplateColumns }}>
      {columns.map((column, i) => (
        <div key={i}>{column.header || ""}</div>
      ))}
    </div>
  );
};

export default TableHeader;
